import { SxProps, Theme } from "@mui/material";

// Common style objects for ReportQuarterTable
export const reportQuarterTableStyles = {
  // DataGrid container styles
  gridContainer: {
    border: "none",
    borderRadius: "8px 8px 0 0",
    overflow: "hidden",
    "& .MuiDataGrid-root": {
      border: "none",
    },
    // Header styles
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#003057",
      borderBottom: "none",
      borderRadius: "8px 8px 0 0",
    },
    "& .MuiDataGrid-columnHeader": {
      borderRight: "none",
      padding: "12px 16px",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "#ffffff",
      fontWeight: "bold",
      fontSize: "0.875rem",
      textTransform: "uppercase",
      fontFamily: '"Poppins", sans-serif',
    },
    // Row styles
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #E0E0E0",
      "&:nth-of-type(odd)": {
        backgroundColor: "#ffffff",
      },
      "&:nth-of-type(even)": {
        backgroundColor: "#F8F8F8",
      },
      "&:hover": {
        backgroundColor: "#F0F0F0",
      },
    },
    // Cell styles
    "& .MuiDataGrid-cell": {
      borderRight: "none",
      color: "#003057",
      fontSize: "0.875rem",
      fontFamily: '"Poppins", sans-serif',
      padding: "12px 16px",
    },
    // Comment column - italic (applied via renderCell, but keeping for consistency)
    "& .MuiDataGrid-cell[data-field='Comment']": {
      fontStyle: "italic",
    },
    // Remove default cell focus outline
    "& .MuiDataGrid-cell:focus": {
      outline: "none",
    },
    "& .MuiDataGrid-cell:focus-within": {
      outline: "none",
    },
  } as SxProps<Theme>,
};
